module.exports = __webpack_public_path__ + "img/symbol_10.c8078cf8.png";